const MODULE_NAME = 'LoadingModule';

// eslint-disable-next-line import/prefer-default-export
export const SET_LOADING_STATE = `${MODULE_NAME}/SET_LOADING_STATE`;
